import {action, observable} from "mobx";
import Menu from "./Menu";
import MenusApi from "./MenusApi";

class MenusStore {
    menuApi: MenusApi;

    @observable items: Menu[] = [];

    constructor(menuApi: MenusApi) {
        this.menuApi = menuApi;
        this.fetch();
    }

    @action fetch = async () => {
        if (!this.items.length) { // get only once
            const items = await this.menuApi.fetch();
            this.items = items.map(item => new Menu(item));
        }
    }

}

export default MenusStore;
